export enum BackdropVariant {
  DEFAULT = "Default",
  AUTH = "Auth",
}
